import { NgModule } from '@angular/core';

import { AnimateNameDirective } from './animate-name/animate-name.directive';
import { BandeiraCartaoDirective } from './bandeira-cartao/bandeira-cartao.directive';

@NgModule({
  imports: [ ],
  declarations: [
    AnimateNameDirective,
    BandeiraCartaoDirective
  ],
  exports: [
    AnimateNameDirective,
    BandeiraCartaoDirective
  ],
})

export class DirectivesModule { }



// WEBPACK FOOTER //
// ./src/app/shared/directives/directives.module.ts